export default __webpack_public_path__ + "df67a9cf864107580fc318d7ddb3a725.jpg";